import Data from '../../common/data';
import { dateFormat, numberFormat } from '../../common/format';

import util from '../../common/util';
import axios from 'axios';

const regBlank = / /g;

export default function (data, options = {}) {
    let mlsOrgHas74 = data.mlsOrg.mlsOrgHas74,
        provided;
    if (data.mlsOrg?.showListingProvider !== false) {
        if (data.mlsOrgId === 30000) {
            let community = data.community,
                chimeBuilderName = data.chimeBuilderName;
            provided =
                community && chimeBuilderName
                    ? `${community} by ${chimeBuilderName}`
                    : `${community || ''}${chimeBuilderName || ''}`;
        } else {
            let agentName =
                    !options.hideAgentName &&
                    Data.house &&
                    !data.mlsOrg.hideAgentName &&
                    data.agentName,
                orgName = data.agentOrganizationName;
            if (agentName || orgName) {
                provided = 'Listed by ';
                if (agentName) {
                    provided += `${agentName} `;
                    if (orgName) {
                        provided += ' of ' + orgName;
                    }
                } else {
                    provided += orgName;
                }
            }
        }
    }
    let fmtData = {
        id: data.id,
        detailUrlTarget:
            util.isMobile && util.inPopDetailPage
                ? '_self'
                : data.target ||
                  (data.soldDate
                      ? Data.listingDetailSoldOpenStyle
                      : Data.listingDetailOpenStyle) ||
                  '_self',
        link: data.detailLink,
        preview: data.previewPicture,
        status: data.listingStatus,
        tour3D: /matterport\.(com|cn)\/show/.test(
            `${data.link} ${data.chimeVideoLink}`
        ),
        picturesNum: data.picturesNum,
        collected: data.collectStatus,
        price: numberFormat(data.price, null, 2, '$ '),
        address: (data.address || '').replace(/, */g, ', '),
        streetAddress: data.streetAddress,
        propertyType: data.propertyType,
        statusOrigin: (data.statusOrigin || '').toLowerCase(), //leased
        desc: data.detailsDescribe || '',
        listingPictures: data.listingPictures || '',
        previewPictures:
            (data.listingPictures && data.listingPictures.split('|')) || [],
        //mls
        latitude: data.latitude,
        longitude: data.longitude,
        showMls: mlsOrgHas74 && data.mlsListingId,
        mlsid: data.mlsListingId,
        mlsLogo: util.isMobile
            ? data.mlsOrg.smallLogo || data.mlsOrg.logo
            : data.mlsOrg.logo,
        provided: provided,
        mlsOrgHas74: mlsOrgHas74,

        //待定
        listingSource: data.listingSource,
        nodisclosureDes: data.nodisclosureDes,
        vow: data.mlsOrg.soldProtected,
        isProtected:
            (data.mlsOrg.soldProtected === 1 &&
                !/Sold/i.test(data.listingStatus)) ||
            (data.mlsOrg.soldProtected === 2 &&
                /Sold/i.test(data.listingStatus)) ||
            data.mlsOrg.soldProtected === 3
    };
    let showListingPrice = Data.house && Data.house.showListingPrice;
    let showSoldPrice = Data.house && Data.house.showSoldPrice;
    if (data.soldDate) {
        let trend = (100 * (data.soldPrice - data.price)) / data.price,
            trendUp = true,
            initialPrice,
            soldPrice,
            markPrice;
        if (trend < 0) {
            trend = -trend;
            trendUp = false;
        }
        if (!showListingPrice && !showSoldPrice) {
            markPrice = soldPrice = '--';
            trend = '';
        } else {
            soldPrice = data.soldPrice;
            markPrice = !showSoldPrice ? data.price : soldPrice;
            initialPrice = data.price;
        }
        Object.assign(fmtData, {
            soldDate: dateFormat('MM/dd/yyyy', data.soldDateStr),
            soldPrice:
                soldPrice === '--'
                    ? '--'
                    : numberFormat(soldPrice, null, 2, '$ '),
            markPrice:
                markPrice === '--'
                    ? '--'
                    : numberFormat(markPrice, null, 2, '$ '),
            initialPrice: numberFormat(initialPrice, null, 2, '$ '),
            trendUp: trendUp,
            trend: trend ? numberFormat(trend, null, 1) + '%' : '',
            flagtext: null
        });
    } else {
        let flag = data.flag || fmtData.status;
        let oldPrice = data.oldPrice || data.oldPriceValue; //中台站和非中台站老价格字段名不一样
        //正则匹配状态是否为open house，展示优先级为open house > price reduced >  new/ new on site > active
        flag = (
            /open\shouse/i.test(flag)
                ? flag
                : data.listingStatus === 'Active' &&
                  data.mlsOrg.showPriceReduced &&
                  data.hasPriceChangedV1 === 1 &&
                  Math.round((oldPrice - data.price) / 1000) > 0 //hasPriceChangedV1===> 1降价，2涨价
                ? 'Price Reduced'
                : flag
        )
            .replace(regBlank, '-')
            .toLowerCase();
        //降价文案
        let priceReduceText =
            'Price Dropped by ' +
            '$' +
            Math.round((oldPrice - data.price) / 1000) +
            'K';
        let listingStatus = { soldDate: null };
        if (data.mlsOrgId == 11) {
            //SITE-16247 11号mls的状态定制
            listingStatus.flag = listingStatus.flagtext = fmtData.status;
        } else {
            listingStatus.flag = flag;
            if (flag === 'open-house' && data.openHouseDesc) {
                listingStatus.flagtext = data.openHouseDesc;
            } else if (flag === 'price-reduced') {
                listingStatus.flagtext = priceReduceText;
            } else if (mlsOrgHas74) {
                if (flag === 'new') {
                    listingStatus.flagtext = 'new to site';
                } else {
                    listingStatus.flagtext = data.flag || fmtData.status;
                }
            } else {
                listingStatus.flagtext = data.flag || fmtData.status;
            }
        }
        Object.assign(fmtData, listingStatus);
    }
    /** TODO：commercialRealEstate is true when propertyType in ["Retail-Commercial", "Office",
      "Industrial", "Business Opportunity", "Shopping Center", "Special Purpose", "Land", "Farm/Ranch"]
      */
    if (data.commercialRealEstate) {
        fmtData.basic = [
            (data.sqft > -1 ? data.sqft : '-') + ' SqFt',
            data.lotSizeWithUnit,
            data.pricePerSqft,
            data.pricePerSqft
        ];
    } else {
        let split = options.breakBasic ? '' : ' ';
        let fixed = 2;
        let bedText =
            data.bedrooms < 1
                ? ''
                : numberFormat(data.bedrooms, false, fixed) +
                  split +
                  (data.bedrooms > 1 ? 'Beds' : 'Bed');
        let bathText =
            data.bathrooms < 1
                ? ''
                : numberFormat(data.bathrooms, false, fixed) +
                  split +
                  (data.bathrooms > 1 ? 'Baths' : 'Bath');
        fmtData.basic = [
            bedText,
            bathText,
            getSqftText(data, false, fixed, split),
            getSqftText(data, true, 0, split)
        ];
    }
    if (window.globalHouseDataFormat) {
        window.globalHouseDataFormat(fmtData);
    }
    // SITE-15435
    if (data.mlsOrg.id == 128) {
        fmtData.soldDate = fmtData.flag = fmtData.flagtext = '';
    }
    //SITE-16247  109号mls房源右下角展示问题
    if (data.mlsOrg.id == 109) {
        fmtData.imgNotZoom = true;
    } else {
        fmtData.imgNotZoom = false;
    }
    return fmtData;
}

/**
 *
 * @param {object} info house listing info
 * @param {boolean} isNeedUnit 是否要转换单位 1000 -> 1k
 * @param {number} Fixed 保留几位小数
 * @param {string} split
 */
const getSqftText = (info, isNeedUnit, Fixed, split) => {
    let text = '';
    if (info.propertyType == 'Vacant Land') {
        if (info.totalAvailableAcres > 0) {
            text =
                numberFormat(
                    info.totalAvailableAcres / (10890 * 4),
                    isNeedUnit,
                    Fixed
                ) +
                split +
                'Acres';
        }
    } else {
        if (info.sqft > 0) {
            text = numberFormat(info.sqft, isNeedUnit, Fixed) + split + 'SqFt';
        } else if (info.totalAvailableAcres >= 10890) {
            text =
                numberFormat(
                    info.totalAvailableAcres / (10890 * 4),
                    isNeedUnit,
                    Fixed
                ) +
                split +
                'Acres Lot';
        } else if (
            info.totalAvailableAcres > 0 &&
            info.totalAvailableAcres < 10890
        ) {
            text =
                numberFormat(info.totalAvailableAcres, isNeedUnit, Fixed) +
                split +
                'Sqft Lot';
        }
    }
    return text;
};
export const Preview = {
    origin: 'previewPicture',
    name: 'preview'
};

export const PreviewNum = {
    origin: 'picturesNum',
    name: 'picturesNum'
};

export function checkSoldHousePreview(result, setResult) {
    let listings = result.listings || [],
        ids = [],
        houseMap = {};
    for (let i = 0, len = listings.length; i < len; i++) {
        let house = listings[i];
        if (
            house.soldDate &&
            !house['listingPictures']
            // !house[Preview.origin]
            // !house[Preview.origin]
        ) {
            ids.push(house.id);
            houseMap[house.id] = house;
        }
    }
    if (ids.length) {
        axios.get(`/picture/sold/${ids.join(',')}`).then(({ data }) => {
            for (let id in data) {
                let previews = data[id] ? data[id].split('|') : [];
                if (
                    previews.length === 1 &&
                    previews[0].indexOf(DEFAULT_HOUSE_PREVIEW) !== -1
                ) {
                    previews.length = 0;
                }
                let house = houseMap[id];
                house.listingPictures = data[id] || '';
                if (!house[Preview.origin]) {
                    house[PreviewNum.origin] = previews.length;
                    house[Preview.origin] =
                        previews[0] || DEFAULT_HOUSE_PREVIEW;
                }
            }
            setResult(JSON.parse(JSON.stringify(result)));
        });
    }
}

export const DEFAULT_HOUSE_PREVIEW =
    '//fs01.chime.me/image/fs/sitebuild/2021224/20/original_ddff9285-b8a4-4fd5-840f-0233eb9cc979.png';
